<template>
  <div
    :style="$register && !isMoviePage ? '' : 'position: relative'"
    data-test-id="showtimes-list"
  >
    <q-scroll-observer
      v-if="$q.screen.xs && !$register && showShowtimesByFilm"
      @scroll="scrollHandler"
    />
    <div
      v-if="moviesAndShowingsByDate"
      data-test-id="showtimes-list"
      :class="($register && !useMobileRegisterLayout) && !isMoviePage ? 'absolute-full row items-start' : ''"
    >
      <template v-if="($q.screen.lt.sm || isPhonePreview) && !($register && !useMobileRegisterLayout) && isMoviePage && showDateFilter">
        <showtimes-date-filter
          v-if="showDatePicker"
          class="row items-center fixed-top sticky-fixed-bar full-width justify-center"
          :style="{ 'padding-top': topMargin }"
          :use-mobile-register-layout="useMobileRegisterLayout"
          is-mobile-view
          :showtimes-date-picker-type="showtimesDatePickerType"
          :showtimes-use-dark-mode="showtimesUseDarkMode"
          :center-align-date-filter="centerAlignDateFilter"
          :allow-past-shows="allowPastShows"
          :formatted-dates-with-showing="formattedDatesWithShowing"
          :initial-date="date"
          :dates-with-showing="datesWithShowing"
          :custom-date="customDate"
          :border-radius="borderRadius"
          :date="date"
          :date-selection="dateSelection"
          :showtimes-allow-all="showtimesAllowAll"
          :initial-site-ids="initialSiteIds"
          :is-movie-page="isMoviePage"
          :all-movies="allMovies"
          :display-dates-without-showings="displayDatesWithoutShowings"
          add-fixed-position
          @date="value => date = value"
          @date-selection="value => dateSelection = value"
          @show-calendar="value => showCalendar = value"
        />
      </template>
      <div v-else-if="showShowtimesDatePickerOnly">
        <showtimes-date-filter
          :all-movies="allMovies"
          :allow-past-shows="allowPastShows"
          :show-date-filter="showDateFilter"
          :use-mobile-register-layout="useMobileRegisterLayout"
          :is-mobile-view="isMobileView"
          :showtimes-display-type-allow-toggle="showtimesDisplayTypeAllowToggle"
          :showtimes-date-picker-type="showtimesDatePickerType"
          :showtimes-use-dark-mode="showtimesUseDarkMode"
          :center-align-date-filter="centerAlignDateFilter"
          :formatted-dates-with-showing="formattedDatesWithShowing"
          :showtimes-allow-all="showtimesAllowAll"
          :initial-date="date"
          :dates-with-showing="datesWithShowing"
          :custom-date="customDate"
          :border-radius="borderRadius"
          :date="date"
          :date-selection="dateSelection"
          :initial-site-ids="initialSiteIds"
          :is-movie-page="isMoviePage"
          :display-dates-without-showings="displayDatesWithoutShowings"
          @date="value => date = value"
          @date-selection="value => dateSelection = value"
        />
      </div>
      <div
        v-else
        class="heading row items-center space-between"
        :class="{
          'q-mt-sm': ($register && !useMobileRegisterLayout),
          'q-mt-md container': !($register && !useMobileRegisterLayout),
          'q-px-md': !($register && !useMobileRegisterLayout) && isMoviePage
        }"
        :style="{ 'background-color': !($register && !useMobileRegisterLayout) && isMoviePage && 'rgba(0,0,0,0.05)' }"
      >
        <p
          v-if="!($register && !useMobileRegisterLayout) && (showTitle || showtimeSiteSelectorType )"
          :class="$q.screen.gt.xs && !isPhonePreview && !setFullWidthHeading && (showDateFilter || showtimesDisplayTypeAllowToggle || hasFilter) ? 'col q-mb-none' : 'text-center full-width justify-center'"
          class="row items-center"
        >
          <section-heading
            v-if="showTitle"
            :heading-color="headingColor"
            :heading-color-hex="headingColorHex"
            :heading-font-size="headingFontSize ? headingFontSize : showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH ? 'h4' : 'h2'"
            :heading-align="headingAlign"
            :heading-type="headingType"
            :heading-background-image-url="headingBackgroundImageUrl"
            :heading-background-image-repeat="headingBackgroundImageRepeat"
            :title="computedTitle"
            :is-mobile-view="isMobileView"
            :light-text="showtimesUseDarkMode"
            :show-site-selector="showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH"
            :is-movie-page="isMoviePage"
            :class="{
              'col': !isMobileView && !setFullWidthHeading,
              'full-width': isMobileView || setFullWidthHeading,
              'text-white': showtimesUseDarkMode
            }"
            class="row items-center"
          />
          <template v-else>
            <span
              v-if="showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH"
              class="text-h4 q-pr-sm"
              :class="{ 'text-white': showtimesUseDarkMode }"
            >{{ $t('common.at') }}</span>

            <site-selector-zones-selectbox
              class="col-auto"
              hide-icon
              flat
              size="lg"
              padding="none sm"
              dense
              :color="showtimesUseDarkMode ? 'white' : 'dark'"
              style="border-bottom: 1px solid; border-radius: 0;"
            />
          </template>
        </p>

        <q-btn-toggle
          v-if="!($register && !useMobileRegisterLayout) && showtimesDisplayTypeAllowToggle && (showtimesDatePickerType === SHOWTIMES_DATE_PICKER_TYPES.SELECTOR && isMobileView)"
          v-model="showtimesDisplay"
          :size="isMobileView ? 'sm' : 'md'"
          :unelevated="true"
          flat
          dense
          class="q-mx-auto"
          :toggle-text-color="showtimesUseDarkMode ? 'white' : 'primary'"
          :text-color="showtimesUseDarkMode ? 'responsive-grey-5' : 'grey-6'"
          :options="[{ value: 'list', slot: 'list' }, { value: 'grid', slot: 'grid' }]"
        >
          <template #list>
            <q-icon
              name="fal fa-list"
            />
          </template>
          <template #grid>
            <q-icon
              :name="gridIcon"
            />
          </template>
        </q-btn-toggle>
        <showtimes-date-filter
          ref="datePicker"
          class="row items-center"
          :class="{
            'col-12': !($register && !useMobileRegisterLayout) && !isMoviePage && centerAlignDateFilter,
            'col-sm-10 col-md-auto': !($register && !useMobileRegisterLayout) && !isMobileView && showtimesDatePickerType === SHOWTIMES_DATE_PICKER_TYPES.SELECTOR && !centerAlignDateFilter,
            'full-width': isMobileView ,
            'justify-center': isMobileView && showDateFilter,
            'justify-between': ((showTitle && showDateFilter) || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH ) && !isMobileView,
            'justify-end': !showTitle && !showDateFilter,
          }"
          :has-filter="hasFilter"
          :show-date-filter="showDateFilter"
          :all-movies="allMovies"
          :allow-past-shows="allowPastShows"
          :use-mobile-register-layout="useMobileRegisterLayout"
          :is-mobile-view="isMobileView"
          :showtimes-display-type-allow-toggle="showtimesDisplayTypeAllowToggle"
          :showtimes-date-picker-type="showtimesDatePickerType"
          :showtimes-use-dark-mode="showtimesUseDarkMode"
          :center-align-date-filter="centerAlignDateFilter"
          :formatted-dates-with-showing="formattedDatesWithShowing"
          :initial-date="date"
          :dates-with-showing="datesWithShowing"
          :custom-date="customDate"
          :border-radius="borderRadius"
          :date="date"
          :date-selection="dateSelection"
          :showtimes-allow-all="showtimesAllowAll"
          :initial-site-ids="initialSiteIds"
          :is-movie-page="isMoviePage"
          @date="value => date = value"
          @date-selection="value => dateSelection = value"
        >
          <template #left-column>
            <q-btn
              v-if="hasFilter && !isMobileView && centerAlignDateFilter"
              class="col-auto"
              stack
              size="sm"
              :text-color="textColor"
              icon="filter_list"
              :label="$t('search.actions.filter')"
              @click="toggleFilter = !toggleFilter"
            />
          </template>

          <template #right-column>
            <q-btn-toggle
              v-if="!($register && !useMobileRegisterLayout) && showtimesDisplayTypeAllowToggle && (!isMobileView || showtimesDatePickerType === SHOWTIMES_DATE_PICKER_TYPES.TOGGLE)"
              v-model="showtimesDisplay"
              :size="isMobileView ? 'sm':'md'"
              :unelevated="true"
              flat
              dense
              style="height: 50px"
              :toggle-text-color="showtimesUseDarkMode ? 'white' : 'primary'"
              :text-color="showtimesUseDarkMode ? 'responsive-grey-5' : 'grey-6'"
              :options="[{ value: 'list', slot: 'list' }, { value: 'grid', slot: 'grid' }]"
            >
              <template #list>
                <q-icon
                  name="fal fa-list"
                />
              </template>
              <template #grid>
                <q-icon
                  :name="gridIcon"
                />
              </template>
            </q-btn-toggle>
          </template>>
        </showtimes-date-filter>
        <showtimes-date-filter
          v-if="addFixedPosition"
          class="row items-center fixed-top sticky-fixed-bar full-width"
          :class="{
            'col-12': !($register && !useMobileRegisterLayout) && !isMoviePage && centerAlignDateFilter,
            'justify-center': isMobileView && showDateFilter,
            'justify-between': ((showTitle && showDateFilter) || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH ) && !isMobileView,
            'justify-end': !showTitle && !showDateFilter,
          }"
          :style="{ 'padding-top': topMargin }"
          :has-filter="hasFilter"
          :show-date-filter="showDateFilter"
          :use-mobile-register-layout="useMobileRegisterLayout"
          :is-mobile-view="isMobileView"
          :showtimes-display-type-allow-toggle="showtimesDisplayTypeAllowToggle"
          :showtimes-date-picker-type="showtimesDatePickerType"
          :showtimes-use-dark-mode="showtimesUseDarkMode"
          :center-align-date-filter="centerAlignDateFilter"
          :allow-past-shows="allowPastShows"
          :formatted-dates-with-showing="formattedDatesWithShowing"
          :initial-date="date"
          :dates-with-showing="datesWithShowing"
          :custom-date="customDate"
          :border-radius="borderRadius"
          :date="date"
          :date-selection="dateSelection"
          :showtimes-allow-all="showtimesAllowAll"
          :initial-site-ids="initialSiteIds"
          :is-movie-page="isMoviePage"
          :all-movies="allMovies"
          add-fixed-position
          @date="value => date = value"
          @date-selection="value => dateSelection = value"
        />
        <q-btn
          v-if="hasFilter && !isMobileView && !centerAlignDateFilter"
          class="col-auto q-ml-auto"
          stack
          size="sm"
          :text-color="textColor"
          :icon="isMoviePage ? 'place' : 'filter_list'"
          :label="isMoviePage ? $tc('siteLocation.location', 1) : $t('search.actions.filter')"
          @click="toggleFilter = !toggleFilter"
        />
      </div>

      <div
        v-if="$consumer && !showShowtimesDatePickerOnly && hasFilter && toggleFilter"
        class="row container col-12 items-center relative-position"
        :class="{ 'q-py-md': $q.screen.lt.md || isPhonePreview }"
        :style="{
          'border-top': (toggleFilter || $q.screen.gt.xs || isPhonePreview) && !isMoviePage ? '1px solid' : undefined,
          'border-color': showtimesUseDarkMode ? 'grey' : 'lightgrey',
          'box-shadow': isMoviePage ? undefined : '0 7px 9px -7px rgba(0, 0, 0, 0.2) inset',
          'padding': isMoviePage ? '0' : '15px 0 0'
        }"
      >
        <div
          v-if="!isMobileView && !isMoviePage"
          class="arrow-up"
          :style="{
            'border-bottom-color': showtimesUseDarkMode ? 'grey' : 'lightgrey',
            right: (showTitle || !showDateFilter || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH) && !setFullWidthHeading ? '30px' : undefined,
            left: (showTitle || !showDateFilter || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.DROPDOWN || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH) && !setFullWidthHeading ? undefined : '30px'
          }"
        />
        <site-selector-button
          class="full-width"
          :class="isMoviePage ? undefined : 'q-mb-md'"
          :shown="!($register && !useMobileRegisterLayout) && ((isMoviePage && currentSite.consumerConfig.showSiteSelectorOnMoviePage && !showLocationsFilter) || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BANNER || showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH)"
          :hide-current-location="currentSite.consumerConfig.hideCurrentLocation"
          :site-selector-site-ids="currentSite.consumerConfig.siteSelectorSiteIds"
          :site-selector-include-address-detail="currentSite.consumerConfig.siteSelectorIncludeAddressDetail"
          :is-movie-page="isMoviePage"
          :is-mobile-view="$q.screen.lt.sm"
          :show-locatios-filter="showLocationsFilter"
          @show-site-selector-drawer="$emit('show-site-selector-drawer')"
        />
        <site-selector-filter
          v-if="showLocationsFilter"
          class="full-width"
          :filtered-locations-ids="filteredLocationsIds"
          :use-current-location="useCurrentLocation"
          @save-locations="(sitesIds, getClosestLocations) => saveLocations(sitesIds, getClosestLocations)"
        />

        <template v-if="useClassFilter && titleClassTabs && titleClassTabs.length > 1">
          <q-tabs
            v-if="!isMobileView"
            v-model="selectedTitleClassId"
            dense
            no-caps
            mobile-arrows
            class="col-auto size-md q-mb-sm"
            :class="{ 'text-white': showtimesUseDarkMode, 'full-width q-mb-sm': showingBadgeFilterOptions.length > 0 }"
            active-color="white"
            active-bg-color="primary"
            :dark="showtimesUseDarkMode"
            indicator-color="transparent"
            align="left"
            style="font-size: 16px"
          >
            <q-tab
              :key="'All'"
              :name="null"
              :label="$t('collection.all')"
              style="border: 1px solid;"
              :style="'border-radius: ' + borderRadius + 'px;'"
              class="q-mr-xs"
            />
            <q-tab
              v-for="titleClass in titleClassTabs"
              :key="titleClass.name"
              :name="titleClass.id"
              :label="titleClass.name"
              style="border: 1px solid;"
              :style="'border-radius: ' + borderRadius + 'px;'"
              class="q-mr-xs"
            />
          </q-tabs>
          <q-select
            v-else
            v-model="selectedTitleClassId"
            :options="titleClassTabs"
            :style="'border-radius: ' + borderRadius + 'px;'"
            :dark="showtimesUseDarkMode || $q.dark.isActive"
            :outline="showtimesUseDarkMode || $q.dark.isActive"
            class="full-width"
            option-label="name"
            option-value="id"
            :label="$t('search.actions.filterBy')"
            stack-lable="false"
            :filled="!showtimesUseDarkMode"
            emit-value
            map-options
            clearable
          />
        </template>

        <div
          v-if="showingBadgeFilterOptions.length > 0"
          class="col-auto"
        >
          <q-tabs
            v-if="isMobileView"
            v-model="tab"
            inline-label
            mobile-arrows
            no-caps
            indicator-color="transparent"
            class="q-pa-none q-ma-none"
          >
            <q-tab
              v-for="showingBadge in showingBadgeFilterOptions"
              :key="showingBadge.id"
              class="q-pa-none q-ma-none"
              @click="toggleShowingBadgeFilter(showingBadge.id)"
            >
              <showing-badge
                :showing-badge="showingBadge"
                :color="showtimesUseDarkMode ? 'white' : 'black'"
                :solid="selectedShowingBadgeId === showingBadge.id"
                :outline="selectedShowingBadgeId !== showingBadge.id"
                clickable
                :size="'md'"
                style="border-width: 0;"
              />
            </q-tab>
          </q-tabs>
          <template v-else>
            <showing-badge
              v-for="showingBadge in showingBadgeFilterOptions"
              :key="showingBadge.id"
              :showing-badge="showingBadge"
              :color="showtimesUseDarkMode ? 'white' : 'black'"
              :solid="selectedShowingBadgeId === showingBadge.id"
              :outline="selectedShowingBadgeId !== showingBadge.id"
              clickable
              :size="'md'"
              style="border-width: 0;"
              @click="toggleShowingBadgeFilter(showingBadge.id)"
            />
          </template>
        </div>
      </div>
      <q-space v-if="($register && !useMobileRegisterLayout)" />
      <q-input
        v-if="($register && !useMobileRegisterLayout) && selectedShowingBadgeFilter"
        class="q-mt-sm"
        label="Filtering By"
        :model-value="selectedShowingBadgeFilter.title"
        clearable
        dense
        @clear="selectedShowingBadgeId = null"
      >
        <template
          v-if="selectedShowingBadgeFilter.iconName"
          #prepend
        >
          <q-icon :name="selectedShowingBadgeFilter.iconName" />
        </template>
      </q-input>
      <q-select
        v-if="($register && !useMobileRegisterLayout) && !isMoviePage"
        :model-value="null"
        :label="$t('search.for.titleGenreActorDate')"
        dense
        outlined
        :use-input="true"
        class="q-ma-sm"
        input-debounce="300"
        :options="filteredMovies"
        style="min-width: 200px;"
        input-style="search"
        @filter="filterMovies"
        @update:model-value="movie => selectMovie(movie)"
      >
        <template #no-option>
          <q-item>
            <q-item-section :class="showtimesUseDarkMode ? 'text-white' : 'text-grey'">
              {{ $t('search.noResults') }}
            </q-item-section>
          </q-item>
        </template>
        <template #append>
          <q-icon
            v-if="search === '' && !selectedMovie"
            name="search"
          />
          <q-icon
            v-else-if="!selectedMovie"
            name="clear"
            class="cursor-pointer"
            @click.stop="search = ''"
          />
          <q-icon
            v-else
            name="clear"
            class="cursor-pointer"
            @click.stop="selectedMovie = null; search = ''"
          />
        </template>
        <template #option="scope">
          <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents"
          >
            <q-item-section avatar>
              <q-img
                no-spinner
                no-transition
                width="30px"
                :src="scope.opt.posterImageSmallUrl"
              />
            </q-item-section>
            <q-item-section>
              {{ scope.opt.name }}
              <q-item-label caption>
                {{ formatDate(scope.opt.dateOfFirstShowing, 'MMM DD, YYYY') }}
              </q-item-label>
            </q-item-section>
          </q-item>
        </template>
      </q-select>
      <showtimes-by-film
        v-if="showShowtimesByFilm"
        :id="id"
        ref="showtimesList"
        :all-movies="allMovies"
        :allow-past-shows="allowPastShows"
        :banner-background="bannerBackground"
        :banner-brightness="bannerBrightness"
        :banner-opacity="bannerOpacity"
        :border-radius="borderRadius"
        :clean-image="cleanImage"
        :compact="showtimeView === SHOWTIME_LIST_VIEW_POS_OPTIONS.SHOWTIMES_BY_FILM_COMPACT"
        :is-movie-page="isMoviePage"
        :movies-and-showings-by-date="moviesAndShowingsByDate"
        :reloading="reloading"
        :shadow="shadow"
        :shown="shown"
        :show-attendance-levels="showAttendanceLevels"
        :show-button-progress-bar="showButtonProgressBar"
        :show-button-progress-bar-in-grid-view="showButtonProgressBarInGridView"
        :show-class="showClass"
        :showings-by-date-and-movie="showingsByDateAndMovie"
        :showings-query="showingsForDate"
        :show-multiple-sites="showMultipleSites"
        :showtimes-grid-button-use-button-drawer="showtimesGridButtonUseButtonDrawer"
        :showtimes-list-button-type="showtimesListButtonType"
        :show-movie-image="showMovieImage"
        :show-movie-synopsis="showMovieSynopsis"
        :movie-synopsis-wrapped="movieSynopsisWrapped"
        :truncated-line-count="truncatedLineCount"
        :mobile-truncated-line-count="mobileTruncatedLineCount"
        :showtimes-grid-button-type="showtimesGridButtonType"
        :showtimes-blocks-background-color="showtimesBlocksBackgroundColor"
        :showtimes-blocks-background-color-hex="showtimesBlocksBackgroundColorHex"
        :showtimes-blocks-text-light="showtimesBlocksTextLight"
        :showtimes-view-type="showtimesViewType"
        :slider-controls-visible="sliderControlsVisible"
        :slider-pagination-visible="sliderPaginationVisible"
        :slider-autoplay="sliderAutoplay"
        :slider-paginate-grouped-slides="sliderPaginateGroupedSlides"
        :slider-delay-in-seconds="sliderDelayInSeconds"
        :slider-gutter="sliderGutter"
        :slider-per-view="sliderPerView"
        :grid-per-row="gridPerRow"
        :showtimes-display-type="showtimesDisplay || showtimesDisplayType"
        :showtimes-use-dark-mode="showtimesUseDarkMode"
        :solid-showing-badges="solidShowingBadges"
        :use-banner="useBanner"
        :show-date-headings="showDateHeadings"
        :show-showing-badge="showShowingBadge"
        :show-trailer-button="showTrailerButton"
        :enable-leaving-soon-banner="enableLeavingSoonBanner"
        :next-showings-available="nextShowingsAvailable"
        :is-filtered="isFiltered"
        :is-phone-preview="isPhonePreview"
        :is-mobile-view="isMobileView"
        :button-type="buttonType"
        :button-color="buttonColor"
        :button-color-hex="buttonColorHex"
        :button-border-radius="buttonBorderRadius"
        @common-showing-badges="commonShowingBadges => $emit('common-showing-badges', commonShowingBadges)"
        @select-movie="movie => selectMovie(movie)"
        @select-showing="showing => $emit('select-showing', showing)"
        @edit-held-seats="showtime => editHeldSeats(showtime)"
        @play-trailer="playTrailer"
        @toggle-showing-badge="showingBadgeId => toggleShowingBadgeFilter(showingBadgeId)"
        @view-next-showings="viewNextShowing"
        @clear-filters="clearFilters"
      />
      <showtimes-by-screen
        v-else-if="showtimeView === SHOWTIME_LIST_VIEW_POS_OPTIONS.SHOWTIMES_BY_CINEMA && !showShowtimesDatePickerOnly"
        :showings-by-screen="showingsByScreen"
        :showings-query="showingsForDate"
        :all-movies="allMovies"
        :banner-background="bannerBackground"
        :banner-brightness="bannerBrightness"
        :banner-opacity="bannerOpacity"
        :solid-showing-badges="solidShowingBadges"
        :show-attendance-levels="showAttendanceLevels"
        :allow-past-shows="allowPastShows"
        :reloading="reloading"
        @common-showing-badges="commonShowingBadges => $emit('common-showing-badges', commonShowingBadges)"
        @select-movie="movie => selectMovie(movie)"
        @select-showing="showing => $emit('select-showing', showing)"
        @edit-held-seats="showtime => editHeldSeats(showtime)"
      />
      <schedule-view
        v-else-if="showtimeView === SHOWTIME_LIST_VIEW_POS_OPTIONS.SHOWTIMES_BY_SCHEDULE && ($register && !useMobileRegisterLayout)"
        class="absolute-full"
        :fit-height="true"
        style="top: 58px; bottom: 3px;"
        :date="date"
        :shown="shown"
        save-label="Save Page For Register Type"
        :can-save="currentUser.admin"
        :showing-query="showingsForDate"
        :screen-ids="ticketViewPage.config.screenIds"
        :show-time-header="ticketViewPage.config.showTimeHeader"
        :show-time-slot-header="ticketViewPage.config.showTimeSlotHeader"
        :show-screen-labels="ticketViewPage.config.showScreenLabels"
        :show-times="ticketViewPage.config.showTimes"
        :show-time-chips="ticketViewPage.config.showTimeChips"
        :show-rating="ticketViewPage.config.showRating"
        :show-seat-chart="ticketViewPage.config.showSeatChart"
        :show-price-card="ticketViewPage.config.showPriceCard"
        :show-showing-badges="ticketViewPage.config.showShowingBadges"
        :show-posters="ticketViewPage.config.showPosters"
        :show-progress-bar="ticketViewPage.config.showProgressBar"
        :highlight-starting-showings="ticketViewPage.config.highlightStartingShowings"
        :highlight-ending-showings="ticketViewPage.config.highlightEndingShowings"
        :highlight-current-showings="ticketViewPage.config.highlightCurrentShowings"
        :show-relative-times="ticketViewPage.config.showRelativeTimes"
        :show-relative-time-chips="ticketViewPage.config.showRelativeTimeChips"
        :show-current-time="ticketViewPage.config.showCurrentTime"
        :hide-distance-showings="ticketViewPage.config.hideDistanceShowings"
        :distant-showing-threshold-hours="ticketViewPage.config.distantShowingThresholdHours"
        :zoom="ticketViewPage.config.zoom"
        @edit-held-seats="showtime => editHeldSeats(showtime)"
        @save="config => ticketViewPage.saveConfig(config)"

        @select-showing="(showing) => $emit('select-showing', showing)"
      />
    </div>
    <held-seat-dialog
      ref="heldSeatDialog"
      @select-showing="showing => $emit('select-showing', showing)"
      @select-order="order => $emit('select-order', order)"
      @request-authorization="callback => $emit('request-authorization', callback)"
    />
    <trailer-player-dialog
      ref="trailerDialog"
      :trailer-youtube-id="trailerYoutubeId"
      :is-phone-preview="isPhonePreview"
    />
  </div>
</template>

<script>

import { Cookies, date } from 'quasar'
import { defineAsyncComponent } from 'vue'
const { formatDate, extractDate } = date
import { TEXT_ALIGN_OPTIONS } from 'src/models/carousel/Carousel'
import { BUTTON_TYPES, HEADING_TYPES, SHOWTIMES_BUTTON_TYPES, SHOWTIMES_DATE_PICKER_TYPES, SHOWTIMES_VIEW_TYPES, SITE_INFO_DISPLAY_TYPES } from 'src/models/page/Section'
import { HEADER_TYPES, SHOWTIME_LIST_VIEW_POS_OPTIONS } from 'src/models/site/Site'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import SectionHeading from 'src/modules/consumer/components/SectionHeading'
import ShowtimesByFilm from 'src/modules/consumer/components/ShowtimesByFilm'
import ShowtimesByScreen from 'src/modules/consumer/components/ShowtimesByScreen'

export default {
  name: 'ShowtimesList',
  components: {
    ShowtimesByFilm,
    ShowtimesByScreen,
    HeldSeatDialog: defineAsyncComponent(() => import('src/modules/consumer/components/HeldSeatDialog')),
    ShowingBadge,
    ScheduleView: defineAsyncComponent(() => import('src/modules/admin/report/ScheduleView')),
    SiteSelectorButton: defineAsyncComponent(() => import('src/modules/consumer/components/site-selector/SiteSelectorButton')),
    SectionHeading,
    TrailerPlayerDialog: defineAsyncComponent(() => import('src/modules/consumer/components/TrailerPlayerDialog')),
    SiteSelectorZonesSelectbox: defineAsyncComponent(() => import('src/modules/consumer/components/site-selector/SiteSelectorZonesSelectbox')),
    SiteSelectorFilter: defineAsyncComponent(() => import('src/modules/consumer/components/site-selector/SiteSelectorFilter')),
    ShowtimesDateFilter: defineAsyncComponent(() => import('src/modules/consumer/components/ShowtimesDateFilter'))
  },
  context: ['currentUser'],
  configuration: ['currentCircuit', 'currentSite', 'titleClasses', 'showingBadges'],
  props: {
    id: {
      type: Number,
      required: false,
      default: 0
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true
    },
    headingColor: {
      type: String,
      default: 'primary',
      required: false
    },
    headingColorHex: {
      type: String,
      default: '#FFFFFF',
      required: false
    },
    headingAlign: {
      type: String,
      default: null,
      required: false
    },
    headingFontSize: {
      type: String,
      default: null,
      required: false
    },
    headingType: {
      type: String,
      default: 'default',
      required: false
    },
    headingBackgroundImageUrl: {
      type: String,
      default: null,
      required: false
    },
    headingBackgroundImageRepeat: {
      type: Boolean,
      required: false,
      default: true
    },
    shown: {
      type: Boolean,
      required: false,
      default: true
    },
    initialDate: {
      type: String,
      required: false,
      default: null
    },
    showDateFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showtimeSiteSelectorType: {
      type: String,
      required: false,
      default: null
    },
    showDateHeading: {
      type: Boolean,
      required: false,
      default: false
    },
    showShowingBadge: {
      type: Boolean,
      required: false,
      default: true
    },
    titleClassId: {
      type: Number,
      required: false,
      default: null
    },
    showingByScreen: {
      type: Boolean,
      required: false,
      default: true
    },
    initialMovieId: {
      type: String,
      required: false,
      default: null
    },
    allowPastShows: {
      type: Boolean,
      default: false
    },
    bannerBackground: {
      type: Boolean,
      required: false,
      default: true
    },
    bannerBrightness: {
      type: Number,
      required: false,
      default: 0.3
    },
    bannerOpacity: {
      type: Number,
      required: false,
      default: 0.8
    },
    solidShowingBadges: {
      type: Boolean,
      required: false,
      default: false
    },
    showAttendanceLevels: {
      type: Boolean,
      required: false,
      default: true
    },
    isMoviePage: {
      type: Boolean,
      required: false,
      default: false
    },
    showButtonProgressBar: {
      type: Boolean,
      required: false,
      default: false
    },
    showButtonProgressBarInGridView: {
      type: Boolean,
      required: false,
      default: false
    },
    overrideShowtimeView: {
      type: String,
      required: false,
      default: null
    },
    initialMovieIds: {
      type: Array,
      required: false,
      default: () => ([])
    },
    initialShowingIds: {
      type: Array,
      required: false,
      default: () => ([])
    },
    initialTitleClassIds: {
      type: Array,
      required: false,
      default: null
    },
    initialSiteIds: {
      type: Array,
      required: false,
      default: null
    },
    showtimesDatePickerType: {
      type: String,
      required: false,
      default: SHOWTIMES_DATE_PICKER_TYPES.TOGGLE
    },
    showtimesViewType: {
      type: String,
      required: false,
      default: SHOWTIMES_VIEW_TYPES.BLOCK
    },
    sliderControlsVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderPaginationVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderAutoplay: {
      type: Boolean,
      required: false,
      default: false
    },
    sliderPaginateGroupedSlides: {
      type: Boolean,
      required: false,
      default: false
    },
    sliderDelayInSeconds: {
      type: Number,
      required: false,
      default: 6
    },
    sliderGutter: {
      type: Number,
      required: false,
      default: 4
    },
    showtimesDisplayType: {
      type: String,
      required: false,
      default: 'list'
    },
    showtimesDisplayTypeAllowToggle: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesListButtonType: {
      type: String,
      required: false,
      default: SHOWTIMES_BUTTON_TYPES.BASIC
    },
    showMovieImage: {
      type: Boolean,
      required: false,
      default: true
    },
    showMovieSynopsis: {
      type: Boolean,
      required: false,
      default: true
    },
    movieSynopsisWrapped: {
      type: Boolean,
      required: false,
      default: true
    },
    truncatedLineCount: {
      type: Number,
      required: false,
      default: 9
    },
    mobileTruncatedLineCount: {
      type: Number,
      required: false,
      default: 3
    },
    showtimesGridButtonType: {
      type: String,
      required: false,
      default: SHOWTIMES_BUTTON_TYPES.COMPACT
    },
    showtimesGridButtonUseButtonDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesBlocksBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    showtimesBlocksBackgroundColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    showtimesBlocksTextLight: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesUseDarkMode: {
      type: Boolean,
      required: false,
      default: false
    },
    showtimesAllowAll: {
      type: Boolean,
      required: false,
      default: false
    },
    useBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    cleanImage: {
      type: Boolean,
      required: false,
      default: false
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 0
    },
    shadow: {
      type: Number,
      required: false,
      default: 0
    },
    showClass: {
      type: Boolean,
      required: false,
      default: false
    },
    useClassFilter: {
      type: Boolean,
      required: false,
      default: false
    },
    showTrailerButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showShowtimesDatePickerOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    useShowingBadgeFilter: {
      type: Boolean,
      required: false,
      default: false
    },
    matchAllShowingBadges: {
      type: Boolean,
      required: false,
      default: true
    },
    filterShowingBadgeIds: {
      type: Array,
      required: false,
      default: null
    },
    filterOptionShowingBadgeIds: {
      type: Array,
      required: false,
      default: null
    },
    ticketViewPage: {
      type: Object,
      required: false,
      default: null
    },
    enableLeavingSoonBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    gridPerRow: {
      type: Number,
      required: false,
      default: 4
    },
    sliderPerView: {
      type: Number,
      required: false,
      default: 3
    },
    buttonType: {
      type: String,
      required: false,
      default: BUTTON_TYPES.UNELEVATED
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    useMobileRegisterLayout: {
      type: Boolean,
      required: false,
      default: false
    },
    displayDatesWithoutShowings: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['show-site-selector-drawer', 'common-showing-badges', 'select-showing', 'select-order', 'request-authorization', 'showtimes-loading', 'select-movie'],
  data () {
    return {
      today: this.currentSite.today,
      tomorrow: this.currentSite.tomorrow,
      errorOccurred: false,
      dateSelection: 'all',
      date: (this.initialDate || this.today),
      customDate: null,
      search: '',
      selectedMovie: null,
      movieId: this.initialMovieId,
      reloading: false,
      titleClassTabs: null,
      selectedTitleClassId: null,
      showtimesDisplay: null,
      trailer: false,
      trailerYoutubeId: null,
      showtimesVisible: false,
      selectedShowingBadgeId: null,
      showSiteSelector: false,
      selectedSiteId: this.currentSite.name,
      toggleFilter: true,
      addFixedPosition: false,
      showtimesLoaded: false,
      showtimeSelectedDate: this.date,
      tab: null,
      initialDateLoaded: false,
      scrollUp: false,
      showDatePicker: false,
      showSiteFilterDialog: false,
      filteredLocationsIds: [],
      useCurrentLocation: false,
      showCalendar: false
    }
  },
  computed: {
    allMovies () {
      return !this.movieId
    },
    computedTitle () {
      return this.title || this.$i18n.t('movie.showtimes')
    },
    showtimeView () {
      if (this.overrideShowtimeView) return this.overrideShowtimeView

      if (this.movieId || !(this.$register && !this.useMobileRegisterLayout) || !this.currentUser?.posShowtimeViewPreference) return SHOWTIME_LIST_VIEW_POS_OPTIONS.SHOWTIMES_BY_FILM

      if (this.currentUser.overridePosShowtimeViewPreference) return this.currentUser.posShowtimeViewPreference

      return this.currentSite.defaultPosShowtimeViewPreference
    },
    currentShowtimes () {
      return _(this.showingsForDate.data)
        .filter(s => {
          if (this.$register && this.allowPastShows) return true

          if (this.$register && this.currentSite.showPastShowingsInPos) return true

          if (this.$consumer && this.currentSite.showPastShowingsOnline) return !s.beforeCutoffTime

          if (this.$consumer) {
            if (this.currentSite.showPastShowingsOnline) return !s.beforeCutoffTime

            if (this.showLocationsFilter) {
              return this.filteredLocationsIds.includes(s.movie.site.id)
            }
          }

          return !s.localPast
        })
    },
    moviesAndShowingsByDate () {
      // Group Showings by Movie
      // Sort Showings within Movies by their showtime (earlier showings display first under a Movie)
      // Sort Movies by their magic sort value
      return _(this.currentShowtimes)
        .groupBy('movie.id')
        .map(showings => {
          _.each(showings, showing => { showing.site = this.currentSite })

          const showingsGroupedByDate = _(showings)
            .groupBy(showing => formatDate(showing.siteTime, 'YYYY-MM-DD'))
            .value()

          const sortedShowingsGroupedByDate = {}
          // Sort Showings within a Movie by showtime
          for (const date in showingsGroupedByDate) {
            sortedShowingsGroupedByDate[date] = _.orderBy(
              showingsGroupedByDate[date],
              ['time', 'screen.displayOrder'],
              ['asc', 'asc']
            )
          }

          return {
            movie: showings[0].movie,
            showings: sortedShowingsGroupedByDate,
            allShowings: showings
          }
        })
        // Sort by movie magic sort value when date is unset
        // Sort by movie day of magic sort value when date is set (ignores prioritisation elements that act across days)
        .sortBy(({ showings }) => {
          const firstShowing = _.values(showings)[0]?.[0]
          return !this.date
            ? firstShowing?.movie.displayMetaData?.magicSortValue
            : firstShowing?.movie.dayOfMagicSortValue
        })
        .value()
    },
    showingsByDateAndMovie () {
      const showingsGroupedByDate = this.currentShowtimes.groupBy(showing => formatDate(showing.siteTime, 'YYYY-MM-DD')).value()
      const showingsGroupedByDateAndMovie = {}

      for (const date in showingsGroupedByDate) {
        showingsGroupedByDateAndMovie[date] =
          _(showingsGroupedByDate[date])
            .groupBy('movie.id')
            .map(showings => {
              _.each(showings, showing => { showing.site = this.currentSite })
              return {
                movie: showings[0].movie,
                showings: _(showings).sortBy(o => o.screen.displayOrder).sortBy('time').value() // Sort first by time, then display order
              }
            })
            .sortBy(({ showings }) => showings[0].movie.displayMetaData?.magicSortValue) // Sort by magic movie value
            .value()
      }

      return showingsGroupedByDateAndMovie
    },
    showingsByScreen () {
      return this.currentShowtimes
        .groupBy('screen.displayOrder')
        .map(showings => {
          _.each(showings, showing => { showing.site = this.currentSite })
          return {
            screen: showings[0].screen,
            showings: _(showings).sortBy('time').value() // Sort first by time
          }
        })
        .sortBy(({ showings, screen }) => screen.displayOrder) // Sort by screen display order
        .value()
    },
    formattedDatesWithShowing () {
      if (!this.datesWithShowing.value || !_.isArray(this.datesWithShowing.value)) return []

      return this.datesWithShowing.value.map(date => date.replace(/-/g, '/'))
    },
    filteredMovies () {
      if (this.search.length === 0) return this.currentAndUpcomingMovies.data
      const searchTerms = this.search.toLowerCase().split(' ')
      const searchFields = ['name', 'synopsis', 'starring', 'genre', 'dateOfFirstShowing']
      return this.currentAndUpcomingMovies.data.filter(movie => {
        return _.every(searchTerms, term => {
          return _.some(searchFields, field => {
            if (!movie[field]) return false

            if (field === 'dateOfFirstShowing') {
              return this.formatDate(movie[field], 'MMMM YYYY dddd D').toLowerCase().includes(term)
            } else {
              return movie[field].toLowerCase().includes(term)
            }
          })
        })
      })
    },
    customDateFormatted () {
      return formatDate(extractDate(this.date + ' 00:00', 'YYYY-MM-DD HH:mm'), 'MMM DD')
    },
    selectedShowingBadgeFilter () {
      if (!this.selectedShowingBadgeId) return null
      return _.find(this.showingBadges.data, { id: this.selectedShowingBadgeId })
    },
    showingBadgeFilterOptions () {
      if (this.matchAllShowingBadges && this.filterOptionShowingBadgeIds?.length) return []

      if (!this.filterOptionShowingBadgeIds?.length && !this.selectedShowingBadgeId) return []

      return _(this.filterOptionShowingBadgeIds || []).concat([this.selectedShowingBadgeId])
        .compact()
        .uniq()
        .map(id => _.find(this.showingBadges.data, { id }))
        .compact()
        .value()
    },
    showDateHeadings () {
      return this.isMoviePage || this.showDateHeading || (this.showtimesDatePickerType === SHOWTIMES_DATE_PICKER_TYPES.TOGGLE && this.showtimesAllowAll && this.dateSelection === 'all')
    },
    showLocationsFilter () {
      // This is for cinema chain who need show movie in their circuit level website
      return this.currentSite.consumerConfig.showSiteSelectorOnMoviePage && this.currentSite.consumerConfig.hideCurrentLocation && this.isMoviePage && !this.$register && this.showMultipleSites
    },
    hasFilter () {
      if (this.$kiosk || (this.$register && !this.useMobileRegisterLayout)) return false
      return (this.isMoviePage && this.currentSite.consumerConfig.showSiteSelectorOnMoviePage) || ((this.showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BANNER || this.showtimeSiteSelectorType === SITE_INFO_DISPLAY_TYPES.BOTH || (this.useClassFilter && this.titleClassTabs && this.titleClassTabs.length > 1) || this.showingBadgeFilterOptions.length > 0) && !this.isMoviePage)
    },
    nextShowingsAvailable () {
      if (_.isEmpty(this.formattedDatesWithShowing)) return null

      const nextShowingDateString = _(this.formattedDatesWithShowing)
        .map(date => date.replace(/\//g, '-'))
        .find(date => date !== this.today)

      if (_.isNil(nextShowingDateString)) return null

      // Create a proper Date object with timezone information to avoid timezone offset issues
      const nextShowingDate = new Date(nextShowingDateString + 'T00:00:00')

      return `${this.$t('showing.nextAvailableShowing')}: ${this.$d(nextShowingDate, 'mediumLongDate')}`
    },
    isFiltered () {
      return ((this.useClassFilter && this.titleClassTabs?.length > 1 && this.selectedTitleClassId !== null) || (this.showingBadgeFilterOptions.length > 0 && this.selectedShowingBadgeId !== null))
    },
    gridIcon () {
      if (this.isMobileView) return 'fal fa-square'
      if (this.showtimesViewType === SHOWTIMES_VIEW_TYPES.SLIDER) return `fal fa-grid-${this.sliderPerView}`
      return `fal fa-grid-${this.gridPerRow}`
    },
    topMargin () {
      if (this.currentSite.consumerConfig.stickyHeader || this.scrollUp) {
        if (window._capacitorNative || this.$capacitor?.isCapacitor) {
          if (this.headerShowTopBar) return '178px'
          return '130px'
        } else {
          if (this.headerShowTopBar) return '118px'
          return '70px'
        }
      } else {
        if (window._capacitorNative || this.$capacitor?.isCapacitor) {
          return '60px'
        } else {
          return '0px'
        }
      }
    },
    headerShowTopBar () {
      return this.currentSite.consumerConfig.headerType !== HEADER_TYPES.DEFAULT && (this.currentSite.consumerConfig.showSiteSelectorOnNavigations || this.currentCircuit.supportsTranslations)
    },
    textColor () {
      if (this.addFixedPosition) return this.$isColorDark(this.currentSite.backgroundColor) ? 'white' : 'black'
      if (this.showtimesUseDarkMode) return 'white'
      if (this.toggleFilter) return 'primary'
      return 'dark'
    },
    configureDarkMode () {
      if (this.addFixedPosition) return this.$isColorDark(this.currentSite.backgroundColor)
      return this.showtimesUseDarkMode
    },
    setFullWidthHeading () {
      return (this.headingType !== HEADING_TYPES.DEFAULT || (this.headingType === HEADING_TYPES.DEFAULT && this.headingAlign === TEXT_ALIGN_OPTIONS.CENTER)) && this.showTitle
    },
    centerAlignDateFilter () {
      return (!this.showTitle && this.showtimeSiteSelectorType !== SITE_INFO_DISPLAY_TYPES.DROPDOWN && this.showtimeSiteSelectorType !== SITE_INFO_DISPLAY_TYPES.BOTH) || this.setFullWidthHeading
    },
    showMultipleSites () {
      return this.isMoviePage && this.currentSite.moviePageConfig.showMoviesAndShowingsForMultipleSites
    },
    showShowtimesByFilm () {
      if (this.showShowtimesDatePickerOnly) return false

      if (this.showLocationsFilter && _.isEmpty(this.filteredLocationsIds)) return false

      return (this.showtimeView === SHOWTIME_LIST_VIEW_POS_OPTIONS.SHOWTIMES_BY_FILM || this.showtimeView === SHOWTIME_LIST_VIEW_POS_OPTIONS.SHOWTIMES_BY_FILM_COMPACT)
    }
  },
  watch: {
    initialMovieId () {
      this.movieId = this.initialMovieId
    },
    dateSelection () {
      if (this.dateSelection === 'today') {
        this.date = this.today
        this.$trackEvent(this.$customerEvents.SHOWTIMES_SELECTED_TODAY)
      } else if (this.dateSelection === 'tomorrow') {
        this.date = this.tomorrow
        this.$trackEvent(this.$customerEvents.SHOWTIMES_SELECTED_TOMORROW)
      } else if (this.dateSelection === 'custom') {
        this.validateDateSelection()
        this.$trackEvent(this.$customerEvents.SHOWTIMES_SELECTED_CUSTOM)
      } else if (this.dateSelection === 'all') {
        this.date = null
        this.validateDateSelection()
        this.$trackEvent(this.$customerEvents.SHOWTIMES_SELECTED_ALL)
      }
    },
    'datesWithShowing.value': {
      handler () {
        if (!!this.date && this.allowPastShows) {
          this.initialDateLoaded = true
          return
        }

        if (!this.datesWithShowing.loaded) return

        if (!this.datesWithShowing.value?.length) {
          this.initialDateLoaded = true
          return
        }

        if (this.date && _.includes(this.datesWithShowing.value, this.date)) {
          this.initialDateLoaded = true
          return
        }

        const initialDate = this.getAndResetInitialDate()
        if (initialDate && _.includes(this.datesWithShowing.value, initialDate)) {
          this.date = initialDate
        } else {
          if ((this.allMovies || this.showMultipleSites || this.$kiosk) && (!this.showtimesAllowAll || !this.showDateFilter || this.showtimesDatePickerType === SHOWTIMES_DATE_PICKER_TYPES.SELECTOR)) {
            this.date = this.initialDate || this.today
          } else {
            this.date = null
          }
        }

        this.validateDateSelection()
        this.initialDateLoaded = true
      },
      immediate: true
    },
    date: {
      handler () {
        if (!this.initialTitleClassIds) {
          this.selectedTitleClassId = null
          this.titleClassTabs = null
        }

        this.validateDateSelection()
      },
      immediate: true
    },
    'showingsForDate.loading' (val) {
      this.$emit('showtimes-loading', val)
    },
    currentShowtimes () {
      if (this.titleClassTabs || !this.currentShowtimes.value() || !this.currentShowtimes.value().length) return

      if (this.initialTitleClassIds) {
        this.titleClassTabs = _(this.initialTitleClassIds).map(titleClassId => _.find(this.titleClasses.data, ({ id }) => id === titleClassId)).compact().value()
      } else {
        this.titleClassTabs = this.currentShowtimes.map(showing => showing.movie.titleClass).uniq().without(null).sortBy('displayOrder').compact().value()
      }
    },
    showtimesDisplayType: {
      handler: function () {
        this.showtimesDisplay = this.showtimesDisplayTypeAllowToggle ? this.showtimesDisplayType : null
      },
      immediate: true
    },
    showtimesDisplayTypeAllowToggle: {
      handler: function () {
        this.showtimesDisplay = this.showtimesDisplayTypeAllowToggle ? this.showtimesDisplayType : null
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, {
      formatDate,
      SHOWTIMES_DATE_PICKER_TYPES,
      SHOWTIME_LIST_VIEW_POS_OPTIONS,
      SITE_INFO_DISPLAY_TYPES,
      HEADING_TYPES,
      TEXT_ALIGN_OPTIONS,
      BUTTON_TYPES,
      HEADER_TYPES
    })
    if (this.showLocationsFilter) {
      const preferredLocations = Cookies.get(this.$constants.cookies.preferredLocations)

      if (preferredLocations && preferredLocations.siteId === this.currentSite.id) {
        const preferredLocationsIds = preferredLocations.preferredLocationsIds
        this.filteredLocationsIds = preferredLocationsIds
        if (preferredLocations.type === this.$constants.cookies.type.useCurrentLocation) {
          this.useCurrentLocation = true
        }
      }
    }

    if (!this.showingsForDate?.options?.skip) {
      if ((this.showMultipleSites && this.dateSelection === 'all') || this.$kiosk) this.showToday()
      this.reset()
    }
    this.fetchShowings()
  },
  unmounted () {
    this.isDestroyed = true

    if (this.fetchShowingsTimeout) {
      clearTimeout(this.fetchShowingsTimeout)
    }
    document.removeEventListener('scroll', this.checkScrolledHeight)
  },
  methods: {
    async reset () {
      this.validateToday()
      this.reloading = true
      await this.datesWithShowing.fetch(true)
      await this.showingsForDate.fetch(true)
      this.reloading = false
    },
    showToday () {
      this.dateSelection = 'today'
      this.customDate = false
    },
    fetchShowings () {
      // Set timeout instead of set interval, prevents call
      // stacking if fetch takes time
      this.fetchShowingsTimeout = setTimeout(async () => {
        if (this.isDestroyed) return
        if (this.showingsForDate.loading) return

        this.validateToday()
        this.reloading = true
        if (!this.datesWithShowing?.options?.skip) {
          await this.datesWithShowing.fetch(true)
        }
        if (!this.showingsForDate?.options?.skip) {
          await this.showingsForDate.fetch(true)
        }
        this.reloading = false

        // Call recursively
        this.fetchShowings()
      }, 20 * 1000)
    },
    validateDateSelection () {
      if (this.date === this.today) {
        this.dateSelection = 'today'
        this.customDate = false
      } else if (this.date === this.tomorrow) {
        this.dateSelection = 'tomorrow'
        this.customDate = false
      } else if (this.date === null) {
        this.dateSelection = 'all'
        this.customDate = false
      } else {
        this.dateSelection = 'custom'
        this.customDate = true
      }
    },

    filterMovies (val, update, abort) {
      update(() => {
        this.search = val
      })
    },
    selectMovie (movie) {
      this.$emit('select-movie', movie)
    },
    validateToday () {
      if (this.today === this.currentSite.today) return

      const oldToday = this.today
      this.today = this.currentSite.today
      this.tomorrow = this.currentSite.tomorrow

      if (this.date === oldToday) {
        this.date = this.today
      }

      this.validateDateSelection()
    },
    editHeldSeats (showtime) {
      this.$refs.heldSeatDialog.show(showtime)
    },

    getAndResetInitialDate () {
      let initialDate = null
      if (this.$route.query.date) {
      // Capture the data
        const dateStr = this.$route.query.date
        const maybeDate = new Date(dateStr)
        if (maybeDate.toDateString() !== 'Invalid Date' && maybeDate.getTime() >= (new Date(this.today)).getTime()) {
          initialDate = dateStr
        }
        // Remove the date from the route
        history.replaceState({}, null, '#' + this.$route.path)
      }

      return initialDate
    },
    toggleDisplay () {
      this.showtimesDisplay = this.showtimesDisplay === 'list' ? 'grid' : 'list'
    },
    playTrailer (playTrailer) {
      if (playTrailer == null) return
      this.trailerYoutubeId = playTrailer
      this.$refs.trailerDialog.show()
    },
    toggleShowingBadgeFilter (showingBadgeId) {
      this.selectedShowingBadgeId = (this.selectedShowingBadgeId === showingBadgeId ? null : showingBadgeId)
    },
    viewNextShowing () {
      // this is because q-date expect date format with - while date-selector expect date format with /
      const nextAvailableShowingDates = this.showtimesDatePickerType === SHOWTIMES_DATE_PICKER_TYPES.TOGGLE ? this.formattedDatesWithShowing.map(date => date.replace(/\//g, '-')) : this.formattedDatesWithShowing
      if (this.datesWithShowing.value.includes(this.today)) {
        this.date = nextAvailableShowingDates[1]
      } else {
        this.date = nextAvailableShowingDates[0]
      }
    },
    clearFilters () {
      if (this.useClassFilter && this.titleClassTabs?.length > 1) this.selectedTitleClassId = null
      if (this.showingBadgeFilterOptions.length > 0) this.selectedShowingBadgeId = null
    },
    scrollHandler (value) {
      if (value.direction === 'up') {
        this.scrollUp = true
      } else {
        this.scrollUp = false
      }

      const containerScroll = this.$refs.showtimesList.$el
      const containerRect = containerScroll.getBoundingClientRect()
      const containerScrollOffsetTop = containerRect.top + value.position.top
      const containerScrollOffsetBottom = containerRect.bottom + value.position.top

      const windowScroll = value.position.top
      const removeFixedPositionOffsetBottom = containerScrollOffsetBottom - 80

      // Check if window scroll has reached the top of the container &&   If the scroll is past the bottom offset, remove the fixed position
      if (windowScroll >= containerScrollOffsetTop && windowScroll <= removeFixedPositionOffsetBottom) {
        this.addFixedPosition = true
      } else {
        this.addFixedPosition = false
      }
      this.showDatePicker = !_.isEmpty(this.moviesAndShowingsByDate) && (windowScroll > 50 || this.showCalendar)
    },
    saveLocations (siteIds, getClosestLocations) {
      this.filteredLocationsIds = siteIds

      const cookieType = getClosestLocations
        ? this.$constants.cookies.type.useCurrentLocation
        : null

      const expiresInDays = getClosestLocations ? 1 : 5

      Cookies.set(this.$constants.cookies.preferredLocations, {
        siteId: this.currentSite.id,
        preferredLocationsIds: siteIds,
        type: cookieType,
        expires: expiresInDays
      })
    }

  },
  models: {
    datesWithShowing: {
      variables () {
        return {
          ids: this.initialShowingIds ? this.initialShowingIds : null,
          movieId: this.movieId ? this.movieId : null,
          movieIds: this.initialMovieIds ? this.initialMovieIds : null,
          titleClassId: this.selectedTitleClassId ? this.selectedTitleClassId : null,
          titleClassIds: this.initialTitleClassIds ? this.initialTitleClassIds : null,
          siteIds: this.initialSiteIds ? this.initialSiteIds : null,
          anyShowingBadgeIds: (!this.matchAllShowingBadges && this.filterShowingBadgeIds?.length) ? this.filterShowingBadgeIds : null,
          everyShowingBadgeIds: (this.matchAllShowingBadges && this.filterShowingBadgeIds?.length) ? this.filterShowingBadgeIds : [this.selectedShowingBadgeId],
          skip: !this.currentSite
        }
      },
      immediate: true
    },
    showingsForDate: {
      movie: 'default',
      showing: {
        movie: 'default',
        screen: 'default',
        seatsRemaining: true,
        seatsRemainingWithoutSocialDistancing: true
      },
      showings: {
        movie: 'default',
        screen: 'default',
        seatsRemaining: true,
        seatsRemainingWithoutSocialDistancing: true
      },
      screen: 'default',
      showingBadges: 'default',
      priceCard: 'default',
      predictedAttendance: true,
      seatsRemaining: true,
      seatsRemainingWithoutSocialDistancing: true,
      titleClass: 'default',
      variables () {
        return {
          date: this.date,
          ids: this.initialShowingIds ? this.initialShowingIds : null,
          movieId: this.movieId ? this.movieId : null,
          movieIds: this.initialMovieIds ? this.initialMovieIds : null,
          titleClassId: this.selectedTitleClassId ? this.selectedTitleClassId : null,
          titleClassIds: this.initialTitleClassIds ? this.initialTitleClassIds : null,
          siteIds: this.initialSiteIds ? this.initialSiteIds : null,
          anyShowingBadgeIds: (!this.matchAllShowingBadges && this.filterShowingBadgeIds?.length) ? this.filterShowingBadgeIds : null,
          everyShowingBadgeIds: (this.matchAllShowingBadges && this.filterShowingBadgeIds?.length) ? this.filterShowingBadgeIds : [this.selectedShowingBadgeId],
          skip: !this.datesWithShowing.loaded || !this.initialDateLoaded || !this.currentSite
        }
      }
    },
    currentAndUpcomingMovies: 'default',
    movie: {
      datesWithShowing: 'default',
      datesWithPublicShowing: 'default',
      variables () {
        return { id: this.movieId && this.movieId }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.heading {
  margin-left: auto;
  margin-right: auto;
}

.text-h2 {
  // background: rgba(33,33,33,.4);
  min-width: unset !important;
  padding: 16px 8px 16px 0;

  color: var(--q-primary);
  font-size: 32px;
  line-height: 1.5rem;

}
.body--light .border-responsive-grey-3{
  border: 3px solid $grey-4;
}
.body--dark .border-responsive-grey-3{
  border: 3px solid rgba(255, 255, 255, 0.4);
}

.times-visible-detector {
  height: 0;
  position: relative;
  top: 85px;
}
.arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid lightgray;
  position: absolute;
  top: -8px;
}
.sticky-fixed-bar {
  top:0;
  background-color: $background;
  z-index: 1000;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  animation: goDown 0.3s ease-in-out forwards;
}

@keyframes goDown {
  0%{
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
